import type { IAppConfigResponse } from '@modules/config/types';
import { CONFIG_QUERY_KEY } from '@modules/config/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  I18N_CHANGE_LOCALE_MUTATION_KEY,
  I18N_CHANGE_URL,
} from '../constants';

export default function useI18nChangeLocaleMutation(): ReturnType<typeof useContextMutation<Record<string, never>, Error, string>> {
  const { fetchGet } = useRestClient();

  return useContextMutation<Record<string, never>, Error, string>({
    mutationKey: [I18N_CHANGE_LOCALE_MUTATION_KEY],
    mutationFn: (locale) => fetchGet<Record<string, never>>(I18N_CHANGE_URL, { queryParams: { locale } }),
    onSuccess: ({ queryClient, variables }) => {
      queryClient.setQueryData<IAppConfigResponse>([CONFIG_QUERY_KEY], (data) => {
        if (!data) {
          return data;
        }

        return {
          ...data,
          locale: variables,
        };
      });
    },
  });
}
